import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBytes32 } from '../../../../Fct/generics';
import { FaSave } from 'react-icons/fa';
import { secureStorageAddressFrom, secureStorageAddresses } from '../helpers/constants';
export var Write_fct_bytes32 = createPlugin({
    protocol: 'SECURE_STORAGE',
    type: 'ACTION',
    method: 'write_fct_bytes32',
    supportedContracts: secureStorageAddresses,
    payerIndex: 0,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                from: new FctAddress({ value: secureStorageAddressFrom[chainId], readonly: true }),
                methodParams: {
                    key: new FctBytes32({ messageType: 'stringOrBytes32', isPreview: true }),
                    value: new FctBytes32({ messageType: 'stringOrBytes32', isPreview: true, icon: FaSave }),
                },
            },
            output: {},
        });
    },
});
